import { apiClient } from '../lib/apiClient';

// Mirrors backend/src/routes/care-team-documents.routes.ts — the provider's own
// document vault (certifications, insurance, agreements, …). File payloads are
// base64, ~10 MB cap.

export const DOC_CATEGORIES = [
  'certifications',
  'training',
  'agreements',
  'insurance',
  'reports',
  'other',
] as const;

export type DocCategory = (typeof DOC_CATEGORIES)[number];

export type ProviderDoc = {
  id: string;
  title: string;
  category: DocCategory;
  notes: string;
  expiryDate: string | null;
  connectionId: string | null;
  fileName: string | null;
  mimeType: string | null;
  fileSize: number | null;
  hasFile: boolean;
  addedAt: string;
};

export type NewDocMeta = {
  title: string;
  category?: DocCategory;
  notes?: string;
  expiryDate?: string | null;
  connectionId?: string | null;
};

export type FileUpload = {
  fileData: string;
  fileName: string;
  mimeType: string;
  fileSize?: number;
};

export const documentsApi = {
  list: () => apiClient.get<ProviderDoc[]>('/care-team-documents'),

  create: (meta: NewDocMeta) => apiClient.post<ProviderDoc>('/care-team-documents', meta),

  update: (id: string, patch: Partial<NewDocMeta>) =>
    apiClient.patch<ProviderDoc>(`/care-team-documents/${id}`, patch),

  uploadFile: (id: string, file: FileUpload) =>
    apiClient.put<ProviderDoc>(`/care-team-documents/${id}/file`, file),

  getFile: (id: string) =>
    apiClient.get<{ fileData: string; fileName: string; mimeType: string; fileSize?: number }>(
      `/care-team-documents/${id}/file`,
    ),

  remove: (id: string) => apiClient.delete<void>(`/care-team-documents/${id}`),
};
